export const FilterType = {
    Meta: 'meta',
    Taxonomy: 'taxonomy'
}

export const StaticFilters = {
  Catalog: {
    handle: 'pa_us-or-eu',
    type: FilterType.Taxonomy
  },
  SampleOptions: {
    handle: 'sample_enabled',
    type: FilterType.Meta
  }
}

export function isStaticFilter(filter) {  
  return [StaticFilters.Catalog.handle, StaticFilters.SampleOptions.handle].includes(filter.handle)
}

export class Filter {
  constructor(
    type,
    name,
    value, //either meta_value or term_id
    handle, //Either meta_key or taxonomy name
    active = false
  ) {
    this.name = name
    this.value = value
    this.handle = handle
    this.active = active
    this.type = type
  }
}
